<template>
  <div>
    <!-- Hero Section -->
    <section class="py-5 bg-white" style="border-bottom: 1px solid #E2E8F0;">
      <CContainer>
        <CRow class="justify-content-center">
          <CCol lg="10" xl="9" class="text-center">
            <h1 class="display-3 font-weight-bold marketing-heading mb-4" style="font-size: 3rem; line-height: 1.1;">
              Malaysian Business <span class="text-marketing-primary">Guides & Resources</span>
            </h1>
            <p class="lead marketing-body mb-4" style="font-size: 1.25rem; max-width: 800px; margin-left: auto; margin-right: auto;">
              Learn everything you need to know about payroll, accounting, and compliance in Malaysia. Free guides written by experts.
            </p>
          </CCol>
        </CRow>
      </CContainer>
    </section>

    <!-- Guides Categories -->
    <section class="py-5 bg-marketing-light">
      <CContainer>
        <!-- Payroll Guides -->
        <div class="mb-5">
          <h2 class="h2 font-weight-bold marketing-heading mb-4">
            <CIcon name="cil-check-circle" class="text-marketing-accent mr-2"/>
            Payroll Guides
          </h2>
          <CRow>
            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Understanding EPF Contributions</h5>
                  <p class="marketing-body mb-3">
                    Complete guide to EPF rates, eligibility, and calculations for employers and employees in 2026.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">SOCSO & EIS Explained</h5>
                  <p class="marketing-body mb-3">
                    Everything you need to know about SOCSO and EIS contributions, registration, and compliance.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Monthly Payroll Checklist</h5>
                  <p class="marketing-body mb-3">
                    Step-by-step checklist to ensure you never miss a payroll deadline or compliance requirement.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>

        <!-- Tax & Compliance Guides -->
        <div class="mb-5">
          <h2 class="h2 font-weight-bold marketing-heading mb-4">
            <CIcon name="cil-shield-alt" class="text-marketing-accent mr-2"/>
            Tax & Compliance Guides
          </h2>
          <CRow>
            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">SST Registration & Filing</h5>
                  <p class="marketing-body mb-3">
                    Complete guide to Sales & Service Tax (SST) registration, rates, and filing requirements with RMCD.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Income Tax for SMEs</h5>
                  <p class="marketing-body mb-3">
                    Understanding corporate income tax, tax reliefs, and deductions for Malaysian small businesses.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Year-End Tax Checklist</h5>
                  <p class="marketing-body mb-3">
                    Essential checklist for year-end tax filing, EA forms, and preparing for your business tax return.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>

        <!-- Accounting Guides -->
        <div class="mb-5">
          <h2 class="h2 font-weight-bold marketing-heading mb-4">
            <CIcon name="cil-chart" class="text-marketing-accent mr-2"/>
            Accounting Guides
          </h2>
          <CRow>
            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Accounting Basics for SMEs</h5>
                  <p class="marketing-body mb-3">
                    Learn the fundamentals of double-entry bookkeeping, chart of accounts, and financial statements.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Cash Flow Management</h5>
                  <p class="marketing-body mb-3">
                    Practical strategies to manage your cash flow and avoid common pitfalls that hurt SMEs.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Financial Reports Explained</h5>
                  <p class="marketing-body mb-3">
                    Understanding Profit & Loss statements, Balance Sheets, and other key financial reports.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>

        <!-- Business Setup Guides -->
        <div>
          <h2 class="h2 font-weight-bold marketing-heading mb-4">
            <CIcon name="cil-building" class="text-marketing-accent mr-2"/>
            Business Setup Guides
          </h2>
          <CRow>
            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Registering Your Sdn Bhd</h5>
                  <p class="marketing-body mb-3">
                    Step-by-step guide to registering a private limited company (Sdn Bhd) with SSM in Malaysia.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Hiring Your First Employee</h5>
                  <p class="marketing-body mb-3">
                    Complete guide to employment contracts, EPF registration, and what you need to know as an employer.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="4" md="6" class="mb-4">
              <CCard class="h-100 border-0 shadow-sm marketing-card-feature hover-lift" style="background: white;">
                <CCardBody class="p-4">
                  <h5 class="font-weight-bold marketing-subheading mb-3">Getting a Business Bank Account</h5>
                  <p class="marketing-body mb-3">
                    What you need to know when opening a business bank account in Malaysia for your SME.
                  </p>
                  <div class="text-muted small">Coming Soon</div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      </CContainer>
    </section>

    <!-- CTA Section -->
    <section class="py-5 bg-marketing-dark text-white" style="background: linear-gradient(135deg, #0F172A 0%, #1E3A5F 100%);">
      <CContainer class="text-center">
        <h2 class="display-4 font-weight-bold mb-4" style="color: white;">
          Ready to Automate Your Business?
        </h2>
        <p class="lead mb-5" style="color: rgba(255, 255, 255, 0.9); max-width: 700px; margin-left: auto; margin-right: auto;">
          Stop manual calculations and spreadsheets. Let Niagaku handle your payroll, invoicing, and accounting automatically.
        </p>
        <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center" style="gap: 1rem;">
          <CButton
            class="btn-marketing-accent mr-sm-3 mb-3 mb-sm-0 px-5 py-3 font-weight-600 btn-scale"
            size="lg"
            to="/signup"
          >
            Start Free 30-Day Trial
          </CButton>
          <CButton
            class="btn-outline-light-custom mr-sm-3 mb-3 mb-sm-0 px-5 py-3 btn-scale"
            size="lg"
            to="/features"
          >
            Explore Features
          </CButton>
        </div>
      </CContainer>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Guides',
  metaInfo: {
    title: 'Business Guides & Resources - Niagaku',
    meta: [
      {
        name: 'description',
        content: 'Free guides and resources for Malaysian SMEs. Learn about payroll, tax compliance, accounting, and running a successful business in Malaysia.'
      }
    ]
  }
}
</script>

<style scoped>
/* Guides page uses marketing CSS classes */
</style>
